import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit';
import { ContentLoading } from '../ContentLoading';
import * as styles from './styles.css';
import { ILocation } from '../../../../../types/location';
import { GeoLocationModalContent } from '../GeoLocationModalContent';

export interface IGeoLocationModalMobileProps {
  /** Заголовок окна **/
  title: string;
  /** Компонент поиска **/
  searchComponent: React.ReactNode;
  /** Модальное окно открыто **/
  isOpen: boolean;
  /** Данные в процессе загрузки **/
  isLoading?: boolean;
  /** Ошибка загрузки **/
  isError?: boolean;
  /** Показать данные поиска **/
  isSearchShown?: boolean;
  /** Основные регионы **/
  specialLocations: ILocation[];
  /** Популярные регионы **/
  locations: ILocation[];
  /** Найденные регионы **/
  foundLocations: ILocation[];

  onClose(): void;
  onRetry(): void;
  onLocationSelect(location: ILocation): void;
}

export const GeoLocationModalMobile: React.FC<IGeoLocationModalMobileProps> = props => {
  const { searchComponent, isOpen, onClose, isLoading, title } = props;

  return (
    <ModalWindow open={isOpen} onClose={onClose} title={title} fixed height="100%">
      <div className={styles['search']}>{searchComponent}</div>
      <div className={styles['content']}>
        <ContentLoading isLoading={isLoading}>
          <GeoLocationModalContent {...props} />
        </ContentLoading>
      </div>
    </ModalWindow>
  );
};

GeoLocationModalMobile.displayName = 'GeoLocationModalMobile';
